export var ChatType;
(function (ChatType) {
    ChatType["Personal"] = "Personal";
    ChatType["Group"] = "Group";
    ChatType["Preview"] = "Preview";
    ChatType["BuilderChat"] = "BuilderChat";
})(ChatType || (ChatType = {}));
//# sourceMappingURL=chat-type.const.js.map